import { DeleteTwoTone, EditTwoTone } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { ListItemIcon, ListItemText } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import ValidateAccess from "../../routes/ValidateAccess";
import { ViewButton } from "../IconButtons";

const ITEM_HEIGHT = 48;

export default function Maxheightmenu_C({
  onDelete,
  onEdit,
  onView,
  isView,
  isEdit,
  isDelete,
}: any) {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={isOpen ? "long-menu" : undefined}
        aria-expanded={isOpen ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        <ValidateAccess accessKey={isView}>
          <MenuItem
            onClick={() => {
              handleClose();
              onView();
            }}
          >
            <ListItemIcon>
              <ViewButton color="primary" />
            </ListItemIcon>
            <ListItemText>View</ListItemText>
          </MenuItem>
        </ValidateAccess>

        <ValidateAccess accessKey={isEdit}>
          <MenuItem
            onClick={() => {
              handleClose();
              onEdit();
            }}
          >
            <ListItemIcon>
              <EditTwoTone color="primary" fontSize="small" />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>
        </ValidateAccess>

        <ValidateAccess accessKey={isDelete}>
          <MenuItem
            onClick={() => {
              handleClose();
              onDelete();
            }}
          >
            <ListItemIcon>
              <DeleteTwoTone color="primary" />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
          </MenuItem>
        </ValidateAccess>
      </Menu>
    </div>
  );
}
